import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../../app.config';
import { DisplayModes } from '../../../models/enums';
import { Page } from '../../../models/page.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { LookupsService } from '../../../services/lookups.service';
import { HcoService } from '../../../settings/components/hco/hco.service';
import { HCPService } from '../hcp.service';
import { PlanStatus } from '../../../plan/enums/plan-status.enum';
import { UsersApiService } from '../../../services/users-api.service';
import { SettingService } from '../../../settings/components/settings/setting.service';

@Component({
  selector: 'crm-adding-request-status',
  templateUrl: './adding-request-status.component.html',
  styleUrls: ['./adding-request-status.component.css']
})
export class AddingRequestStatusComponent implements OnInit {
 
  columns: any[] = [];
  showEnglishName: boolean = false;
  @ViewChild('filterModal')
  filterModal: ModalDirective;
  search: any = {};
  currentPage: number = 1;
  users: any[] = [];
  pageSize = 10;
  totalItems: number = 0;
  countAllPages: number = 1;
  logo = "";
  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'HCO List :',
    useBom: true,
    noDownload: false,
    headers: ["ID", "Name", "Requester Name", "Creation Date", "Status", "Approval/Rejection Date", "Approval/Rejection By"]
  };
  displayMode = DisplayModes.Success;
  hcps: any[] = [];
  firstList = true;
  statuses = [{ id: 2, name: 'Pending' }, { id: 3, name: 'Approved' }, { id: 4, name: 'Rejected' }]

  constructor(private alertService: AlertService, private readonly usersService: UsersApiService,
    private lookupsService: LookupsService,
    private hcpService: HCPService, private readonly hcoService: HcoService,
    private readonly appConfig: AppConfigService,
    private readonly settingService: SettingService,
    private translateService: AppTranslationService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.searchHcps();
    this.getAllUsers();
    this.columns = [
      { field: 'id', header: this.translateService.getTranslation("hcps.code"), width: '5%' },
      { field: 'fullName', header: this.translateService.getTranslation("app.name"), width: '20%' },
      { field: 'createdByName', header: this.translateService.getTranslation("Requester Name"), width: '11%' },
      { field: 'creationDate', header: this.translateService.getTranslation("Creation Date"), width: '11%' },
      { field: 'addingStatus', header: this.translateService.getTranslation("Status"), width: '15%' },
      { field: 'approvalLevelStatus', header: 'Approval Level Status', width: '15%' },
      { field: 'approvalLevel', header: 'Approval Level', width: '15%' },
      { field: 'lastModificationDate', header: this.translateService.getTranslation("Approval/Rejection Date"), width: '10%' },
      { field: 'lastModifiedByName', header: this.translateService.getTranslation("Approval/Rejection By"), width: '10%' }

    ];
    this.getEnglishNameSetting();
  }

  getEnglishNameSetting() {
    this.settingService.getCustomFieldLabelConfig('HCPCostumFieldLabel').subscribe(config => {
      this.showEnglishName = config.show;
      if (config.show) {
        this.columns.splice(2, 0, { field: 'englishName', header: config.label, width: '20%' });
      }
    });
  }

  getAllUsers() {
    this.displayMode = DisplayModes.Loading;
    this.usersService.getAllUsersMiniReport().subscribe(response => {
      this.users = response as any[];

      this.displayMode = DisplayModes.Success;
    }, error => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showStickyMessage("Load Data Error", "The below errors occured whilst fetch data from server:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);

    });
  }

  searchHcps() {

    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    this.displayMode = DisplayModes.Loading;

    this.search.statusId = undefined;
    if (this.search.status)
      this.search.statusId = this.search.status.id;

    if (this.search.user)
      this.search.userId = this.search.user.id;

    this.hcpService.getUserAddingReuqest(this.search.startDate, this.search.endDate, this.search.statusId, this.currentPage, this.pageSize, this.search.userId, this.search.searchText).subscribe(response => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Success;

      const result = response as Page;
      this.hcps = result.items;
      this.totalItems = result.totalItems;
      this.countAllPages = Math.ceil(this.totalItems / 10000);
    }, err => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }

  pageChanged(event) {

    this.currentPage = event.first / event.rows + 1;
    if (!this.firstList)
      this.searchHcps();
    else
      this.firstList = !this.firstList;
  }

  openFilterModal() {
    this.filterModal.show();
  }



  hideFilterModal() {

    this.filterModal.hide();
  }

  searchFilterModal() {
    this.filterModal.hide();
    this.currentPage = 1;
    this.searchHcps();
  }

  downloadCSV() {
    this.search.statusId = undefined;
    if (this.search.status)
      this.search.statusId = this.search.status.id;

    if (this.search.user)
      this.search.userId = this.search.user.id;
    this.hcpService.getUserAddingReuqest(this.search.startDatee, this.search.endDate, this.search.statusId, 1, 100000, this.search.userId, this.search.searchText).subscribe(response => {
      let result = response as Page;
      const csvData = result.items.map(o => {
        return {
          id: o.id, name: o.name, createdByName: o.createdByName, creationDate: o.creationDate, addingStatus: this.getPlanStatusName(o.addingStatus), lastModificationDate: o.lastModificationDate, lastModifiedBy: o.lastModifiedByName,
        };

      });
      new AngularCsv(csvData, "HCOs", this.csvOptions);
    })

  }


  getPlanStatusName(status: number): string {
    return PlanStatus[status];
  }

}
